module.exports = __webpack_public_path__ + "assets/carpenter.svg?a6aba53a8af7965a5ab801367720e3d8";